import { FaustTemplate, useFaustQuery } from "@faustwp/core";
import { useMemo } from "react";
import { Channels, Page } from "@/queries/RockHallTV";
import { RhtvChannelsQuery, RhtvPageQuery } from "@/__generated__/graphql";
import { useRouter } from "next/router";
import { getBasicQueryVars, getDefaultRHTVVideo, getUrlLocale } from "@/core/utils";
import { useTracking } from "@/providers/TrackingContext";
import RockHallTVView from "./RockHallTV/RockHallTVView";

const RockHallTVPage: FaustTemplate<any> = ({ loading }: FaustPageProps<any>) => {
  const pageData = useFaustQuery<RhtvPageQuery>(Page);
  const channels = useFaustQuery<RhtvChannelsQuery>(Channels);
  const router = useRouter();

  const channelSlug = useMemo(() => {
    const params = router.query;
    if (params?.wordpressNode && Array.isArray(params.wordpressNode) && params.wordpressNode.length > 2) {
      return params.wordpressNode[2];
    }
    return null;
  }, [router.asPath]);

  const defaultChannel = useMemo(() => {
    if (channelSlug && channels?.rhtvChannels?.nodes) {
      return channels.rhtvChannels.nodes.find((ch) => ch?.slug === channelSlug) || null;
    }
    return null;
  }, [channelSlug, channels]);

  const defaultVideo = useMemo(() => {
    const params = router.query;
    const videoSlug = Array.isArray(params?.wordpressNode) ? params.wordpressNode[4] : null;
    return getDefaultRHTVVideo(defaultChannel, videoSlug);
  }, [defaultChannel]);

  if (loading) return;

  return (
    <RockHallTVView
      page={pageData?.rhPage}
      channels={channels?.rhtvChannels?.nodes || []}
      defaultChannel={defaultChannel}
      defaultVideo={defaultVideo}
    />
  );
};

RockHallTVPage.queries = [
  {
    query: Page,
    variables: getBasicQueryVars,
  },
  {
    query: Channels,
    variables: ({ uri }) => ({ language: getUrlLocale(uri) }),
  }
];

export default RockHallTVPage;
